import { UIElement } from "./ui_element.js";

export class UIElementHolder extends UIElement
{
  private DBG_SHOW_AREA: boolean = false;

  constructor(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
    dbg_show_area: boolean = false,
    is_scalable_on_click = false
  )
  {
    super( ctx, x, y, width, height, false, is_scalable_on_click );
    this.DBG_SHOW_AREA = dbg_show_area;
  }

  name(): string { return 'UIElementHolder'; }

  protected override syncDomContent( _node: HTMLElement ): boolean { return true; }

  render(): void
  {
    if ( !this.shouldBeRendered() )
      return;

    this.startRender();

    if ( this.DBG_SHOW_AREA )
      this.drawRectAreaForTest();

    this.finishRender();
  }
}
